import { render } from "./DonationForm.vue?vue&type=template&id=7070ff2a&scoped=true&ts=true"
import script from "./DonationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationForm.vue?vue&type=script&setup=true&lang=ts"

import "./DonationForm.vue?vue&type=style&index=0&id=7070ff2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7070ff2a"],['__file',"src/js/components/style-six/DonationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7070ff2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7070ff2a', __exports__)) {
    api.reload('7070ff2a', __exports__)
  }
  
  module.hot.accept("./DonationForm.vue?vue&type=template&id=7070ff2a&scoped=true&ts=true", () => {
    api.rerender('7070ff2a', render)
  })

}


export default __exports__